import { clientPostBlobWrapper } from "../api/Api";
import { INSTAGRAM_NAME_FILLER_UPLOAD } from "../common/constants/routes";

/**
 * Upload Excel file with Instagram names to the backend for processing
 * @param {FormData} formData - FormData containing the xlsx file
 * @returns {Promise} - API response with processing results as a blob
 */
export const uploadInstagramNamesExcel = (formData) => {
    return clientPostBlobWrapper(INSTAGRAM_NAME_FILLER_UPLOAD, formData, true);
};
